const measureCanvas = document.createElement('canvas');
const measureContext = measureCanvas.getContext('2d');
let measureNode = null;

const widthCache = new Map();
const heightCache = new Map();
const MAX_CACHE_ENTRIES = 2000;

function trimCache(cache) {
    if (cache.size > MAX_CACHE_ENTRIES) {
        cache.clear();
    }
}

function getFontString(fontname, fontsize, fontPrefix) {
    return (fontPrefix ? fontPrefix + ' ' : '') + fontsize + 'px ' + fontname;
}

function getMeasureNode() {
    if (!measureNode) {
        measureNode = document.createElement('div');
        measureNode.style.position = 'absolute';
        measureNode.style.visibility = 'hidden';
        measureNode.style.pointerEvents = 'none';
        measureNode.style.left = '-10000px';
        measureNode.style.top = '-10000px';
        measureNode.style.padding = '0';
        measureNode.style.margin = '0';
        measureNode.style.border = '0';
        measureNode.style.whiteSpace = 'normal';
        measureNode.style.lineHeight = 'normal';
        document.body.appendChild(measureNode);
    }

    return measureNode;
}

function measureWidth(txt, fontname, fontsize, fontPrefix) {
    const text = txt == null ? '' : String(txt);
    const key = ['w', fontPrefix || '', fontsize, fontname, text].join('|');

    if (widthCache.has(key)) {
        return widthCache.get(key);
    }

    measureContext.font = getFontString(fontname, fontsize, fontPrefix);
    const width = measureContext.measureText(text).width;

    widthCache.set(key, width);
    trimCache(widthCache);
    return width;
}

function measureHeight(txt, fontname, fontsize, width, fontPrefix) {
    const text = txt == null ? '' : String(txt);
    const widthToUse = Number(width) > 0 ? Number(width) : 0;
    const key = ['h', fontPrefix || '', fontsize, fontname, widthToUse, text].join('|');

    if (heightCache.has(key)) {
        return heightCache.get(key);
    }

    const node = getMeasureNode();
    node.style.fontFamily = fontname;
    node.style.fontSize = fontsize + 'px';
    node.style.fontWeight = fontPrefix && fontPrefix.includes('bold') ? 'bold' : 'normal';
    node.style.fontStyle = fontPrefix && fontPrefix.includes('italic') ? 'italic' : 'normal';
    node.style.width = widthToUse > 0 ? widthToUse + 'px' : 'auto';
    node.textContent = text;

    const height = node.offsetHeight;
    heightCache.set(key, height);
    trimCache(heightCache);
    return height;
}

function clear() {
    widthCache.clear();
    heightCache.clear();
}

export default {
    clear: clear,
    measureHeight: measureHeight,
    measureWidth: measureWidth
};